import { api } from '../utils/apiClient';

export const settingsService = {
  // { channels: [{key, name, configured, webhook_url}], events_api_key (masked) }
  async getChannelStatus() {
    return api.get('/settings/channels');
  },
};
